import React, { useContext, useState } from "react";
//import DivRow from "../controlsNR/DivRowNR";
import DivRow from "../controlsNR/DivRowNR";
import Input from "../controlsNR/InputNR";
import InputFile from "../controlsNR/InputFile2";
import DropDownInput from "../controls/DropDownInput";
import SwitchButton from "../controls/SwitchButton";
import {
  DataContextReclamo,
  DataProvier,
} from "../../context/DataContextReclamo";
import {
  TooltipPolizaTramite
} from "../../utils/constanst";
const Step3 = () => {

  const { tramite, setTramite, changeHandler } = useContext(DataContextReclamo);

  const {
    figura
  } = tramite;

  let lblCertificadoTransito = "Adjunte fotografía de Certificado de Tránsito";
  let lblPoliza ="Ingresá tu número de póliza LAFISE";
  let IsRequiredCertificadoTransito = false;
  let IsRequiredInfo = false;
  let cssNegritoRequerido = "";
  if(figura){
     lblCertificadoTransito = "Adjunte fotografía de Certificado de Tránsito*";
     lblPoliza = "Ingresá el número de póliza LAFISE"
     IsRequiredCertificadoTransito = true;
     IsRequiredInfo = true;
     cssNegritoRequerido  = "negrita-nr";
  }

  const handleChange = (e) =>
    setTramite({ ...tramite, [e.target.name]: e.target.value });

  const onChangeFiles = (files, id) => {
    setTramite({ ...tramite, [id]: files });
  };
  return (
    <div className="step">
      <DivRow width="100%">
        <InputFile
          label="Fotografía de la parte trasera del vehículo"
          id="imgParteTraseraVehiculo"
          className="btn-file"
          field="imgParteTraseraVehiculo"
          files={tramite.imgParteTraseraVehiculo}
          handlerFiles={onChangeFiles}
          label2 ="Ambas caras. Máximo 5 archivos JPG o PNG"
          maxFile="5"
        />
        <InputFile
          label="Fotografía de la parte lateral derecha del vehículo"
          id="imgParteLateralDerechaVehiculo"
          files={tramite.imgParteLateralDerechaVehiculo}
          handlerFiles={onChangeFiles}
          label2 ="Ambas caras, Máximo 5 archivos JPG o PNG"
          maxFile="5"
        />
        <InputFile
          label="Fotografía de la parte lateral izquierda del vehículo"
          id="imgParteLateralIzquierdaVehiculo"
          files={tramite.imgParteLateralIzquierdaVehiculo}
          handlerFiles={onChangeFiles}
          label2 ="Ambas caras. Máximo 5 archivos JPG o PNG"
          maxFile="5"
        />
        <InputFile
          label="Fotografía de la circulación de tu vehículo*"
          id="imgCirculacionVehiculo"
          files={tramite.imgCirculacionVehiculo}
          handlerFiles={onChangeFiles}
          isRequired  = "true"
          label2 ="Máximo 2 archivos JPG o PNG"
          maxFile ="2"
          classTitle = "negrita-nr"
        />
        <InputFile
          label={lblCertificadoTransito}
          id="imgCertificadoTransito"
          files={tramite.imgCertificadoTransito}
          handlerFiles={onChangeFiles}
          label2 ="Máximo 2 archivos JPG o PNG"
          isRequired  = {IsRequiredCertificadoTransito}
          maxFile ="2"
          classTitle = {cssNegritoRequerido}
        />
      </DivRow>
    </div>
  );
};

export default Step3;
